import Show from '../show'

function VendorDashboard() {
  return (
    <Show
      title="Vendor Dashboard"
      dashboardKey="vendor_dashboards"
      showYear={false}
    />
  )
}

export default VendorDashboard
